import React, { Fragment, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { icons } from '../../assets/icons/index';
import { useSelector, useDispatch } from 'react-redux';
import { logout } from '../../api/redux/slices/Auth';
import 'react-toastify/dist/ReactToastify.css';
import { clearCheckList as clearCheckListAdmin } from '../../api/redux/slices/Admin';
import { clearCheckList as clearCheckListCustomer } from '../../api/redux/slices/Customer';
import { ButtonComponent } from '../../components/buttons';
import Logo from '../../assets/jeunessee.png';

export const handleLogout = (dispatch, token, navigate) => {
    localStorage.removeItem('accesstoken');
    localStorage.clear();
    
    dispatch(logout({ token: token }))
        .unwrap()
        .then(() => {
            window.location.replace('/login');
        })
        .catch(() => {
            window.location.replace('/login');
        });
};

const NavBar = () => {
	const { pathname } = useLocation();
	const currentPage = pathname.split('/')[2];
	const [pageSelected, setPageSelected] = useState(currentPage);
	const { role } = useSelector((state) => state.auth);
	const dispatch = useDispatch();
	const token = localStorage.getItem('accesstoken');
	const [disconnectModal, setDisconnectModal] = useState(false);
	const naviagte = useNavigate();

	useEffect(() => {
		setPageSelected(currentPage);
	}, [currentPage]);

	if (pathname === '/login') {
		return null;
	}

	const handleNavigateAdmin = (page) => {
		setPageSelected(page);
		dispatch(clearCheckListAdmin());
	};


	const handleNavigateCustomer = (page) => {
		setPageSelected(page);
		dispatch(clearCheckListCustomer());
	};

	return (
		<div className='sidebar'>
			<div style={{ position: 'absolute' }} />
			<div className='content'>
				<div id='logoBox'>
					<img src={Logo} className='sidelogo' alt='logo jeuness' />
				</div>
				<ul id='nav'>
					{role === 'admin' && (
						<Fragment>
              <Link to='/admin/companyProfile'>
								<li
									className={
										pageSelected === 'companyProfile' || pageSelected === undefined
											? 'navItem active'
											: 'navItem'
									}
									onClick={() => handleNavigateAdmin('companyProfile')}
								>
									<icons.BsBuilding />
									<span>Profile de Société</span>
								</li>
							</Link>
              <Link to='/admin/profile'>
								<li
									className={
										pageSelected === 'profile' 
											? 'navItem active'
											: 'navItem'
									}
									onClick={() => handleNavigateAdmin('profile')}
								>
									<icons.CgProfile />
									<span>Profile</span>
								</li>
							</Link>
              
              <Link to={`/admin/dashboard`}>
								<li
									className={pageSelected === 'dashboard' ? 'navItem active' : 'navItem'}
									onClick={() => handleNavigateAdmin('dashboard')}
								>
									<icons.RiHome5Line />
									<span>Tableau de bord</span>
								</li>
							</Link>
							
							<Link to={`/admin/users/${1}`}>
								<li
									className={pageSelected === 'users' ? 'navItem active' : 'navItem'}
									onClick={() => handleNavigateAdmin('users')}
								>
									<icons.RiUserSearchLine />
									<span>Liste des Clients</span>
								</li>
							</Link>
							<Link to={`/admin/categories/${1}`}>
								<li
									className={pageSelected === 'categories' ? 'navItem active' : 'navItem'}
									onClick={() => handleNavigateAdmin('categories')}
								>
									<icons.BiCategory />
									<span>Catégories</span>
								</li>
							</Link>
							<Link to={`/admin/products/${1}`}>
								<li
									className={pageSelected === 'products' ? 'navItem active' : 'navItem'}
									onClick={() => handleNavigateAdmin('products')}
								>
									<icons.BsBoxSeam />
									<span>Produits</span>
								</li>
							</Link>
							<Link to={`/admin/orders/${1}`}>
								<li
									className={pageSelected === 'orders' ? 'navItem active' : 'navItem'}
									onClick={() => handleNavigateAdmin('orders')}
								>
									<icons.TbClipboardText />
									<span>Bons de commandes</span>
								</li>
							</Link>
							<Link to={`/admin/deliveries/${1}`}>
								<li
									className={pageSelected === 'deliveries' ? 'navItem active' : 'navItem'}
									onClick={() => handleNavigateAdmin('deliveries')}
								>
									<icons.TbTruckDelivery />
									<span>Bons de livraisons</span>
								</li>
							</Link>
							<Link to={`/admin/bills/${1}`}>
								<li
									className={pageSelected === 'bills' ? 'navItem active' : 'navItem'}
									onClick={() => handleNavigateAdmin('bills')}
								>
									<icons.VscChecklist />
									<span>Factures Proformat</span>
								</li>
							</Link>
              <Link to={`/admin/facture/${1}`}>
								<li
									className={pageSelected === 'facture' ? 'navItem active' : 'navItem'}
									onClick={() => handleNavigateAdmin('facture')}
								>
									<icons.VscChecklist />
									<span>Factures</span>
								</li>
							</Link>
							<Link to={`/admin/complaints/${1}`}>
								<li
									className={pageSelected === 'complaints' ? 'navItem active' : 'navItem'}
									onClick={() => handleNavigateAdmin('complaints')}
								>
									<icons.BiMailSend />
									<span>Réclamations</span>
								</li>
							</Link>
              <Link to={`/admin/financements/${1}`}>
								<li
									className={pageSelected === 'financements' ? 'navItem active' : 'navItem'}
									onClick={() => handleNavigateAdmin('financements')}
								>
									<icons.BsWallet />
									<span>Financement</span>
								</li>
							</Link>
						</Fragment>
					)}
					{role === 'super-admin' && (
						<Fragment>
              <Link to={`/superadmin/companies/${1}`}>
								<li
									className={pageSelected === 'companies' || pageSelected === undefined ? 'navItem active' : 'navItem'}
									onClick={() => setPageSelected('companies')}
								>
									<icons.BsListTask />
									<span>Liste Des Sociétés</span>
								</li>
							</Link>
              <Link to={`/superadmin/parrainages/${1}`}>
								<li
									className={pageSelected === 'parrainages' ? 'navItem active' : 'navItem'}
									onClick={() => setPageSelected('parrainages')}
								>
									<icons.BsBank />
									<span>Flux de Parrainage</span>
								</li>
							</Link>
              <Link to={`/superadmin/contenaires/${1}`}>
								<li
									className={pageSelected === 'contenaires' ? 'navItem active' : 'navItem'}
									onClick={() => setPageSelected('contenaires')}
								>
									<icons.BsInbox />
									<span>Contenaires</span>
								</li>
							</Link>
              <Link to={`/superadmin/financements/${1}`}>
								<li
									className={pageSelected === 'financements' ? 'navItem active' : 'navItem'}
									onClick={() => setPageSelected('financements')}
								>
									<icons.BsCash />
									<span>Financement</span>
								</li>
							</Link>
              <Link to={`/superadmin/clients/${1}`}>
								<li
									className={pageSelected === 'clients' ? 'navItem active' : 'navItem'}
									onClick={() => setPageSelected('clients')}
								>
									<icons.RiUserSearchLine />
									<span>Liste Des Clients</span>
								</li>
							</Link>
							<Link to={`/superadmin/users/${1}`}>
								<li
									className={pageSelected === 'users' ? 'navItem active' : 'navItem'}
									onClick={() => setPageSelected('users')}
								>
									<icons.BsShield />
									<span>Liste administrateurs</span>
								</li>
							</Link>
            
							<Link to={`/superadmin/complaints/${1}`}>
								<li
									className={pageSelected === 'complaints' ? 'navItem active' : 'navItem'}
									onClick={() => setPageSelected('complaints')}
								>
									<icons.BiMailSend />
									<span>Réclamations</span>
								</li>
							</Link>
						</Fragment>
					)}
					{role === 'customer' && (
						<Fragment>
							<Link to='/client/profile'>
								<li
									className={
										pageSelected === 'profile'
											? 'navItem active'
											: 'navItem'
									}
									onClick={() => handleNavigateCustomer('profile')}
								>
									<icons.CgProfile />
									<span>Profile</span>
								</li>
							</Link>
              <Link to='/client/companies'>
								<li
									className={
										pageSelected === 'companies'
											? 'navItem active'
											: 'navItem'
									}
									onClick={() => handleNavigateCustomer('companies')}
								>
									<icons.BsBuilding />
									<span>Sociétés</span>
								</li>
							</Link>
							<Link to={`/client/categories/${1}`}>
								<li
									className={pageSelected === 'categories' ? 'navItem active' : 'navItem'}
									onClick={() => handleNavigateCustomer('categories')}
								>
									<icons.BiCategory />
									<span>Catégories</span>
								</li>
							</Link>
							<Link to={`/client/products/${1}`}>
								<li
									className={pageSelected === 'products'  || pageSelected === undefined ? 'navItem active' : 'navItem'}
									onClick={() => handleNavigateCustomer('products')}
								>
									<icons.BsBoxSeam />
									<span>Produits</span>
								</li>
							</Link>
							<Link to='/client/orders/1'>
								<li
									className={pageSelected === 'orders' ? 'navItem active' : 'navItem'}
									onClick={() => handleNavigateCustomer('orders')}
								>
									<icons.TbClipboardText />
									<span>Bons de commandes</span>
								</li>
							</Link>
							<Link to='/client/bills/1'>
								<li
									className={pageSelected === 'bills' ? 'navItem active' : 'navItem'}
									onClick={() => handleNavigateCustomer('bills')}
								>
									<icons.VscChecklist />
									<span>Factures Proformat</span>
								</li>
							</Link>
              <Link to='/client/facture/1'>
								<li
									className={pageSelected === 'facture' ? 'navItem active' : 'navItem'}
									onClick={() => handleNavigateCustomer('facture')}
								>
									<icons.VscChecklist />
									<span>Factures</span>
								</li>
							</Link>
							<Link to='/client/complaints/1'>
								<li
									className={pageSelected === 'complaints' ? 'navItem active' : 'navItem'}
									onClick={() => handleNavigateCustomer('complaints')}
								>
									<icons.BiMailSend />
									<span>Réclamations</span>
								</li>
							</Link>
						</Fragment>
					)}
				
					<li className='logout' onClick={() => setDisconnectModal(true)}>
						<icons.IoMdLogOut />
						<span>Se deconnecter</span>
					</li>
				</ul>
			</div>
			{disconnectModal && (
				<>
					<div className='modal-delete'>
						<div className='delete-confirmation-modal'>
							<p>{'Voulez-vous vraiment vous déconnecter?'}</p>
							<div className='modal-btns'>
								<button
									className='button-nature-inactive'
									onClick={() => setDisconnectModal(false)}
								>
									Annuler
								</button>
								<ButtonComponent
									name={'Déconnecter'}
									type={'button'}
									className={'button-primary'}
									onClick={() => {
										setDisconnectModal(false);
										handleLogout(dispatch, token, naviagte);
									}}
								/>
							</div>
						</div>
					</div>
				</>
			)}
		</div>
	);
};

export default NavBar;
